@use '../../../design-tokens/border-radius/border-radius' as *;
@use '../../../design-tokens/typography/typography' as *;

@layer design-system {
  .radioGroup {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .radioGroupWrapper {
    [data-separator] {
      margin-top: 4px;
    }
  }

  .label {
    @include typography-v2-body-xs;
    color: var(--text-soft);
    padding: 2px 16px;
    text-transform: uppercase;
  }

  .radioItemWrapper {
    display: flex;
    gap: 4px;
    padding-right: 8px;
  }

  .radioItemSelected {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 4px;
    width: 4px;
  }

  .radioButton {
    display: flex;
    align-items: center;
    padding: 8px;
    @include border-radius-r1;
    width: 100%;
    gap: 8px;
  }

  .radioItemLabel {
    @include typography-v2-body-sm;
    width: 100%;
  }

  .radioItem {
    all: unset;

    &[data-state='checked'] {
      .radioItemSelected {
        background-color: var(--surface-primary);
      }

      .radioButton {
        background-color: var(--surface-active);
      }
    }

    &:not([data-state='checked']):hover {
      background-color: var(--surface-hover);
      cursor: pointer;
    }
  }

  .separator {
    height: 1px;
    background-color: var(--border-soft);
  }
}
